<template>
    <div v-if="$store.state.user.enterprise_type == 'paid'">
        <Header></Header>
        <search
            ref="search"
            search-type="ecosystems"
            v-on:invite="invite"
        >

        </search>

        <invite
            ref="invite"
            v-on:inviteSent="$refs.search.getList()"
        >
        </invite>
    </div>
</template>

<script>
import Search from "@/views/Search"
import ecosystems from "@/services/ecosystems.service"
import Invite from "@/components/connections/Invite"
import Vue from "vue";
import Header from "@/components/ecosystems/Header";

export default {
    components: {
        Search,
        Invite,
        Header,
    },

    mounted() {
        this.$store.watch(state => {
            if (typeof state.user.enterprise_type != 'undefined' && state.user.enterprise_type != 'paid') {
                this.$store.commit('setPageNotFound', true)
            }
        })
    },

    methods: {
        invite(id) {
            ecosystems.getAccountInfo(id).then(response => {
                if (response.data.registered) {
                    if (confirm('Send connection request?')) {
                        ecosystems.addConnection({id: id}).then(response => {
                            if (!Object.keys(response.data.errors).length) {
                                this.$refs.search.getList()

                                Vue.notify({
                                    group: 'app',
                                    type: 'success',
                                    duration: 5000,
                                    text: response.data.result
                                })
                            }
                        })
                    }
                }
                else {
                    this.$refs.invite.open(id)
                }
            })
        }
    }
}
</script>